<template>
  <div>
    <!-- <div class="file_search">
      <a-input-search placeholder="按文件名搜索" style="width: 180px" v-model="fileName" @change="searchHandler" />
    </div> -->
    <div class="file_content">
      <div style="flex: auto">
        <a-table size="small" :loading="loading" :columns="columns" :dataSource="list" :pagination="false" :rowKey="row => row.id">
          <a-button type="link" slot="name" slot-scope="row" @click="clickItem(row)">
            {{ row.name }}
          </a-button>
          <span slot="creator"></span>
          <span slot="sizeDesc" slot-scope="sizeDesc">{{ sizeDesc }}</span>
          <span slot="time" slot-scope="time">{{ time }}</span>
        </a-table>
        <!-- <div class="file_pagination" v-if="totalNum > 0">
          <a-pagination
            size="small"
            showSizeChanger
            :pageSize="pageSize"
            :total="totalNum"
            :current="currentPage"
            @change="changePage"
            @showSizeChange="changeSize"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getGatherList, taskQuery, taskQueryByCompanyId } from '@/api/document';
export default {
  props: {
    projectId: {
      type: String
    },
    time: {
      type: String,
      default: ''
    },
    portfolioTabType: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      columns: [
        { title: '文件名', scopedSlots: { customRender: 'name' }, width: 250 },
        {
          title: '上传人',
          dataIndex: 'creator',
          align: 'center',
          width: 50
        },
        {
          title: '文件大小',
          dataIndex: 'size',
          align: 'center',
          customRender: (text, record) => {
            if (text < 1024) {
              return text + 'KB';
            } else {
              return Math.floor(text / 1024) + 'MB';
            }
          },
          width: 70
        },
        {
          title: '上传时间',
          dataIndex: 'createAt',
          align: 'center',
          scopedSlots: { customRender: 'time' },
          width: 100
        }
      ],
      list: [],
      loading: false,
      documentList: [],
      pageSize: 100,
      totalNum: 0,
      currentPage: 1,
      fileName: ''
    };
  },
  computed: {
    timeData() {
      if (this.time && this.time.split) {
        let [year, quarter] = this.time.split('-');
        return {
          year,
          quarter
        };
      }
      return {};
    }
  },
  watch: {
    time() {
      console.log('time changed:', this.time);
      this.getList();
    },
    portfolioTabType() {
      console.log('portfolioTabType 1111 changed:', this.portfolioTabType);
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },

  methods: {
    changePage(value) {
      this.currentPage = value;
      this.getList();
    },
    changeSize(page, size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    clickItem(item) {
      let routeLink = this.$router.resolve({ path: '/pdfview/finish', query: { id: item.id, taskId: item.taskId } });
      window.open(routeLink.href);
    },
    searchHandler() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      taskQueryByCompanyId({
        companyIds: this.projectId,
        searchName: this.fileName,
        page: this.currentPage,
        pageSize: this.pageSize,
        ...this.timeData,
        portfolioTabType: this.portfolioTabType
      })
        .then(res => {
          if (res.code === 200) {
            this.$emit('updateData');
            let list = [];
            res.data.detail &&
              res.data.detail.list &&
              res.data.detail.list.forEach(i => {
                i.tasks &&
                  i.tasks.forEach(j => {
                    j.companyFiles &&
                      j.companyFiles.forEach(n => {
                        list.push({
                          ...n,
                          id: n.fileId,
                          taskId: j.id,
                          name: n.fileName,
                          creator: n.uploadUser,
                          createAt: moment(n.createAt * 1000).format('YYYY-MM-DD HH:mm:ss')
                        });
                      });
                  });
              });
            this.$set(this, 'list', list);
            this.totalNum = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.file_search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  padding: 0 20px;
}
.file_content {
  display: flex;
  flex: auto;
  .ant-table-wrapper {
    width: 100%;
  }
  .ant-menu-vertical {
    border: none !important;
  }
}
.file_pagination {
  margin: 10px 0;
  text-align: right;
}
</style>
